export default "__VITE_ASSET__Bq_XcgHZ__"